import axiosInstance from './axiosInstance'

export const getMapData = () => {
  return axiosInstance.get('/map/data')
}
